import { Card, CardContent, CardProps } from '@material-ui/core';
import { CardTitleTypography } from 'framework/components/CardTitleTypography';
import { isLast } from 'framework/utils/array/isLast';
import { IReturn } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { ReturnLineListItem } from './ReturnLineListItem';

interface IProps extends CardProps {
	item: IReturn;
}

export const ReturnDetailContentsCard = ({ item, ...rest }: IProps) => {
	const strings = useLocalization();

	return (
		<Card {...rest}>
			<CardContent>
				<CardTitleTypography
					title={strings.contents}
					style={{ marginBottom: 8 }}
				/>
				{item.lines.map(t => (
					<ReturnLineListItem
						line={t}
						key={t.id}
						withoutBorder={isLast(t, item.lines)}
					/>
				))}
				{item.lines.length === 0 && <em>{strings.noLinesDefinedYet}</em>}
			</CardContent>
		</Card>
	);
};
